"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUDIT_TYPE_CODES = void 0;
var AUDIT_TYPE_CODES;
(function (AUDIT_TYPE_CODES) {
    AUDIT_TYPE_CODES["ENABLE_PRE_TOUR_AUTOMATION"] = "ENABLE_PRE_TOUR_AUTOMATION";
    AUDIT_TYPE_CODES["ENABLE_APPOINTMENT_REMINDER_AUTOMATION"] = "ENABLE_APPOINTMENT_REMINDER_AUTOMATION";
    AUDIT_TYPE_CODES["ENABLE_POST_TOUR_AUTOMATION"] = "ENABLE_POST_TOUR_AUTOMATION";
    AUDIT_TYPE_CODES["ENABLE_RESIDENT_OUTREACH_AUTOMATION"] = "ENABLE_RESIDENT_OUTREACH_AUTOMATION";
    AUDIT_TYPE_CODES["ENABLE_RENT_REMINDER_AUTOMATION"] = "ENABLE_RENT_REMINDER_AUTOMATION";
    AUDIT_TYPE_CODES["ENABLE_LEASE_RENEWAL_AUTOMATION"] = "ENABLE_LEASE_RENEWAL_AUTOMATION";
    AUDIT_TYPE_CODES["ENABLE_LOST_LEAD_AUTOMATION"] = "ENABLE_LOST_LEAD_AUTOMATION";
    AUDIT_TYPE_CODES["ENABLE_DELINQUENCY_AUTOMATION"] = "ENABLE_DELINQUENCY_AUTOMATION";
    AUDIT_TYPE_CODES["ENABLE_VALID_OPT_IN_SOURCES"] = "ENABLE_VALID_OPT_IN_SOURCES";
    AUDIT_TYPE_CODES["ENABLE_PROSPECT_SOURCE"] = "ENABLE_PROSPECT_SOURCE";
    AUDIT_TYPE_CODES["ENABLE_RESIDENT_SOURCE"] = "ENABLE_RESIDENT_SOURCE";
    AUDIT_TYPE_CODES["ENABLE_AVAILABILITY_SOURCE"] = "ENABLE_AVAILABILITY_SOURCE";
    AUDIT_TYPE_CODES["ENABLE_TOUR_SCHEDULING_SOURCE"] = "ENABLE_TOUR_SCHEDULING_SOURCE";
    AUDIT_TYPE_CODES["ENABLE_LEDGER_BALANCE_SOURCE"] = "ENABLE_LEDGER_BALANCE_SOURCE";
    AUDIT_TYPE_CODES["ENABLE_TEXT_OPT_IN_AUTOMATION"] = "ENABLE_TEXT_OPT_IN_AUTOMATION";
    AUDIT_TYPE_CODES["MISSING_DEFAULT_FIELDS_ALERT"] = "MISSING_DEFAULT_FIELDS_ALERT";
    AUDIT_TYPE_CODES["MISSING_CONCESSION_ALERT"] = "MISSING_CONCESSION_ALERT";
    AUDIT_TYPE_CODES["BOT_DISABLED_ALERT"] = "BOT_DISABLED_ALERT";
    AUDIT_TYPE_CODES["LOW_CONTACTS_PRE_TOUR_AUTOMATION"] = "LOW_CONTACTS_PRE_TOUR_AUTOMATION";
    AUDIT_TYPE_CODES["LOW_CONTACTS_POST_TOUR_AUTOMATION"] = "LOW_CONTACTS_POST_TOUR_AUTOMATION";
    AUDIT_TYPE_CODES["LOW_CONTACTS_RESIDENT_OUTREACH_AUTOMATION"] = "LOW_CONTACTS_RESIDENT_OUTREACH_AUTOMATION";
    AUDIT_TYPE_CODES["LOW_CONTACTS_RENT_REMINDER_AUTOMATION"] = "LOW_CONTACTS_RENT_REMINDER_AUTOMATION";
    AUDIT_TYPE_CODES["LOW_CONTACTS_LEASE_RENEWAL_AUTOMATION"] = "LOW_CONTACTS_LEASE_RENEWAL_AUTOMATION";
    AUDIT_TYPE_CODES["LOW_CONTACTS_INTEREST_LIST_AUTOMATION"] = "LOW_CONTACTS_INTEREST_LIST_AUTOMATION";
    AUDIT_TYPE_CODES["LOW_CONTACTS_LOST_LEAD_AUTOMATION"] = "LOW_CONTACTS_LOST_LEAD_AUTOMATION";
    AUDIT_TYPE_CODES["LOW_CONTACTS_DELINQUENCY_AUTOMATION"] = "LOW_CONTACTS_DELINQUENCY_AUTOMATION";
    AUDIT_TYPE_CODES["ADD_STEPS_TO_PRE_TOUR_AUTOMATION"] = "ADD_STEPS_TO_PRE_TOUR_AUTOMATION";
    AUDIT_TYPE_CODES["ADD_STEPS_TO_POST_TOUR_AUTOMATION"] = "ADD_STEPS_TO_POST_TOUR_AUTOMATION";
    AUDIT_TYPE_CODES["ADD_STEPS_TO_RESIDENT_OUTREACH_AUTOMATION"] = "ADD_STEPS_TO_RESIDENT_OUTREACH_AUTOMATION";
    AUDIT_TYPE_CODES["ADD_STEPS_TO_LEASE_RENEWAL_AUTOMATION"] = "ADD_STEPS_TO_LEASE_RENEWAL_AUTOMATION";
})(AUDIT_TYPE_CODES = exports.AUDIT_TYPE_CODES || (exports.AUDIT_TYPE_CODES = {}));
